module.exports = __webpack_public_path__ + "img/bg_breeds_dog.aff5aa8d.png";